module.exports = "/_next/static/images/6d573e8eb511959a3c54e5cee1637ead-roxinho-card-with-phone-xs@1x.png.webp";